// extracted by mini-css-extract-plugin
module.exports = {"swiperContainer":"Slider_swiperContainer__2SPLc","swiperWrapper":"Slider_swiperWrapper__1SGJ8","swiperPagination":"Slider_swiperPagination__KPdj2"};